/* eslint-disable */
/**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2015, Codrops
 * http://www.codrops.com
 */
;(function(window) {

	'use strict';

	var support = { transitions: Modernizr.csstransitions },
		// transition end event name
		transEndEventNames = { 'WebkitTransition': 'webkitTransitionEnd', 'MozTransition': 'transitionend', 'OTransition': 'oTransitionEnd', 'msTransition': 'MSTransitionEnd', 'transition': 'transitionend' },
		transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ],
		onEndTransition = function( el, callback ) {
			var onEndCallbackFn = function( ev ) {
				if( support.transitions ) {
					if( ev.target != this ) return;
					this.removeEventListener( transEndEventName, onEndCallbackFn );
				}
				if( callback && typeof callback === 'function' ) { callback.call(this); }
			};
			if( support.transitions ) {
				el.addEventListener( transEndEventName, onEndCallbackFn );
			}
			else {
				onEndCallbackFn();
			}
		},
		// the pages wrapper
		stack = document.querySelector('.pages-stack'),
		// the page elements
		pages = [].slice.call(stack.children),
		// total number of page elements
		pagesTotal = pages.length,
		// index of current page
		current = 0,
		// menu button
		menuCtrl = document.querySelector('button.menu-button'),
        // arrow nav
        arrowNav = document.querySelector('.arrow-nav'),
        // all arrows
        arrows = document.querySelectorAll('button.arrow'),
        // left arrow
        arrowPrev = document.querySelector('button.arrow--prev'),
        // right arrow
        arrowNext = document.querySelector('button.arrow--next'),
        // mute
        mute = document.querySelector('button.mute'),
		// the navigation wrapper
		nav = document.querySelector('.pages-nav'),
		// the menu nav items
		navItems = [].slice.call(nav.querySelectorAll('.link--page')),
		// check if menu is open
		isMenuOpen = false;

	function init() {
		buildStack();
		initEvents();
	}

	function buildStack() {
		var stackPagesIdxs = getStackPagesIdxs();

		// set z-index, opacity, initial transforms to pages and add class page--inactive to all except the current one
		for(var i = 0; i < pagesTotal; ++i) {
			var page = pages[i],
				posIdx = stackPagesIdxs.indexOf(i);

			if( current !== i ) {
				classie.add(page, 'page--inactive');

				if( posIdx !== -1 ) {
					// visible pages in the stack
					page.style.WebkitTransform = 'translate3d(0,100%,0)';
					page.style.transform = 'translate3d(0,100%,0)';
				}
				else {
					// invisible pages in the stack
					page.style.WebkitTransform = 'translate3d(0,75%,-300px)';
					page.style.transform = 'translate3d(0,75%,-300px)';
				}
			}
			else {
				classie.remove(page, 'page--inactive');
			}

			page.style.zIndex = i < current ? parseInt(current - i) : parseInt(pagesTotal + current - i);

			if( posIdx !== -1 ) {
				page.style.opacity = parseFloat(1 - 0.1 * posIdx);
			}
			else {
				page.style.opacity = 0;
			}
		}
	}

	// event binding
	function initEvents() {
        // next slide arrow
        mute.addEventListener('click', muteSound);

        // previous slide arrow
        arrowPrev.addEventListener('click', previousSlide);

        // next slide arrow
        arrowNext.addEventListener('click', nextSlide);

        // menu button click
        menuCtrl.addEventListener('click', toggleMenu);

		// navigation menu clicks
		navItems.forEach(function(item) {
			// which page to open?
			var pageid = item.getAttribute('href').slice(1);
			item.addEventListener('click', function(ev) {
				ev.preventDefault();
                // Open the page clicked
				openPage(pageid);
                // Show the arrow navigation
                showArrowNav();
			});
		});

		// clicking on a page when the menu is open triggers the menu to close again and open the clicked page
		pages.forEach(function(page) {
			var pageid = page.getAttribute('id');
			page.addEventListener('click', function(ev) {
				if( isMenuOpen ) {
					ev.preventDefault();
                    // Open the page clicked
					openPage(pageid);
                    // Show the arrow navigation
                    showArrowNav();
				}
			});
		});

		// keyboard navigation events
		document.addEventListener( 'keydown', function( ev ) {
			var keyCode = ev.keyCode || ev.which;
			if( keyCode === 27 ) {
				closeMenu();
			} else if (keyCode === 37) {
                previousSlide();
            } else if (keyCode === 39) {
                nextSlide();
            }
		} );
	}

	// toggle menu fn
	function toggleMenu() {
		if( isMenuOpen ) {
			closeMenu();
		}
		else {
			openMenu();
			isMenuOpen = true;
		}
	}

    function muteSound() {
        mute.classList.toggle('mute--active');

        var videos = document.querySelectorAll('video');
        var muteActive = (mute.classList.contains('mute--active')) ? true : false;

        [].forEach.call(videos, function(video) {
            video.muted = muteActive;
        });
    }

    function showArrowNav() {
        arrowNav.classList.remove('arrow-nav--hide');
    }

    function hideArrowNav() {
        arrowNav.classList.add('arrow-nav--hide');
    }

    function disableArrows() {
        arrows.forEach(function(item) {
            item.setAttribute('disabled', 'disabled');
            setTimeout(() => {
                item.removeAttribute('disabled');
            }, 1000);
        });
        menuCtrl.setAttribute('disabled', 'disabled');
        setTimeout(() => {
            menuCtrl.removeAttribute('disabled');
        }, 1000);
    }

    function arrowControl() {
        if (current == 0) {
            arrowPrev.classList.add('arrow--disabled');
        } else if (current == (pagesTotal - 1)) {
            arrowNext.classList.add('arrow--disabled');
        } else {
            arrowPrev.classList.remove('arrow--disabled');
            arrowNext.classList.remove('arrow--disabled');
        }
    }

    function previousSlide() {
        var index = current - 1;

        if (index < 0) return;

        var slide = document.querySelector('[data-page-index="' + index + '"]');
        var slideId = slide.getAttribute('id');

        disableArrows();
        openPage(slideId);
    }

    function nextSlide() {
        var index = current + 1;

        if (index > pagesTotal) return;

        var slide = document.querySelector('[data-page-index="' + index + '"]');
        var slideId = slide.getAttribute('id');

        disableArrows();
        openPage(slideId);
    }

    function resetGif() {
        var slide = document.querySelector('[data-page-index="' + current + '"]');
        [].forEach.call(slide.querySelectorAll('img'), (img) => {
          if (img.src.includes('.gif')) {
              img.src = img.src;
          }
        })
    }

    function playSlideVideo() {

        var slide = document.querySelector('[data-page-index="' + current + '"]');
        var videos = window.innerWidth <= 768 ? slide.querySelectorAll('video.mobile') : slide.querySelectorAll('video.desktop');

        [].forEach.call(videos, function(video) {
            video.play();
        });
    }

    function pauseAllVideos() {

        var videos = document.querySelectorAll('video');

        [].forEach.call(videos, function(video) {
            video.pause();
        });

    }

	// opens the menu
	function openMenu() {

        // pause videos on all slides
        pauseAllVideos();

        // Hide the arrow navigation
        hideArrowNav();

		// toggle the menu button
		classie.add(menuCtrl, 'menu-button--open')
		// stack gets the class "pages-stack--open" to add the transitions
		classie.add(stack, 'pages-stack--open');
		// reveal the menu
		classie.add(nav, 'pages-nav--open');

		// now set the page transforms
		var stackPagesIdxs = getStackPagesIdxs();
		for(var i = 0, len = stackPagesIdxs.length; i < len; ++i) {
			var page = pages[stackPagesIdxs[i]];
			page.style.WebkitTransform = 'translate3d(0, 75%, ' + parseInt(-1 * 200 - 50*i) + 'px)'; // -200px, -230px, -260px
			page.style.transform = 'translate3d(0, 75%, ' + parseInt(-1 * 200 - 50*i) + 'px)';
		}
	}

	// closes the menu
	function closeMenu() {
		// same as opening the current page again
		openPage();

        // Show the arrow navigation
        showArrowNav();
	}

	// opens a page
	function openPage(id) {

        // pause videos on all slides
        pauseAllVideos();

		var futurePage = id ? document.getElementById(id) : pages[current],
			futureCurrent = pages.indexOf(futurePage),
			stackPagesIdxs = getStackPagesIdxs(futureCurrent);

		// set transforms for the new current page
		futurePage.style.WebkitTransform = 'translate3d(0, 0, 0)';
		futurePage.style.transform = 'translate3d(0, 0, 0)';
		futurePage.style.opacity = 1;

		// set transforms for the other items in the stack
		for(var i = 0, len = stackPagesIdxs.length; i < len; ++i) {
			var page = pages[stackPagesIdxs[i]];
			page.style.WebkitTransform = 'translate3d(0,100%,0)';
			page.style.transform = 'translate3d(0,100%,0)';
		}

		// set current
		if( id ) {
			current = futureCurrent;
		}

        // Disable and enable navigation arrows
        arrowControl();

        // play / pause videos in slide
        playSlideVideo();

    resetGif();

		// close menu..
		classie.remove(menuCtrl, 'menu-button--open');
		classie.remove(nav, 'pages-nav--open');
		onEndTransition(futurePage, function() {
			classie.remove(stack, 'pages-stack--open');
			// reorganize stack
			buildStack();
			isMenuOpen = false;
		});
	}

	// gets the current stack pages indexes. If any of them is the excludePage then this one is not part of the returned array
	function getStackPagesIdxs(excludePageIdx) {
		var nextStackPageIdx = current + 1 < pagesTotal ? current + 1 : 0,
			nextStackPageIdx_2 = current + 2 < pagesTotal ? current + 2 : 1,
			idxs = [],

			excludeIdx = excludePageIdx || -1;

		if( excludePageIdx != current ) {
			idxs.push(current);
		}
		if( excludePageIdx != nextStackPageIdx ) {
			idxs.push(nextStackPageIdx);
		}
		if( excludePageIdx != nextStackPageIdx_2 ) {
			idxs.push(nextStackPageIdx_2);
		}

		return idxs;
	}

	init();

})(window);



// WEBPACK FOOTER //
// ./scripts/slides.js